import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import SEO from "./SeoHelmet";
import metaConfig from "./SeoComponent";
import { useLocation } from "react-router-dom";

const VisionandMission = () => {
  const location = useLocation(); // Get the current location (path)
  const meta = metaConfig.visionandmission;

  return (
    <div>
      <SEO {...meta} />
      <div class="container-fluid position-relative p-0">
        <div class="w-100 me-3 top_head">
          <div class="top_head align-items-center"></div>
        </div>
        <Header />
      </div>
      {/* <!-- Navbar & Hero End -->
    <!-- Header Start --> */}
      <div class="container-fluid visionmission bg-breadcrumb">
        <div class="container text-center py-5" style={{ maxWidth: "9000px" }}>
          <ol
            class="breadcrumb d-flex justify-content-center mb-0 wow fadeInDown"
            data-wow-delay="0.3s"
          ></ol>
          <h4
            class="text-white display-4 mb-4 wow fadeInDown"
            data-wow-delay="0.1s"
          >
            Innovation and Technology
          </h4>
        </div>
      </div>
      {/* <!-- Header End --> */}

      {/* <!-- Modal Search Start --> */}
      <div
        class="modal fade"
        id="searchModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div class="modal-dialog modal-fullscreen">
          <div class="modal-content rounded-0">
            <div class="col-lg-12 m-auto modal-header justify-content-lg-end">
              <button
                type="button"
                class="btn-close justify-content-lg-end text-white"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div class="col-lg-9 m-auto modal-header align-items-center text-center">
              <h4
                class="modal-title mb-0 m-auto text-white"
                id="exampleModalLabel"
              >
                Search by keyword
              </h4>
            </div>
            <div class="modal-body align-items-center">
              <div class="input-group w-75 mx-auto d-flex">
                <input
                  type="search"
                  class="form-control p-3"
                  placeholder="keywords"
                  aria-describedby="search-icon-1"
                />
                <span
                  id="search-icon-1"
                  class="input-group-text btn border p-3"
                >
                  <i class="fa fa-search text-white"></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Modal Search End --> */}

      <div class="container-fluid innercontain ktig_services_page non_it_details_1 overflow-hidden py-5">
        <div class="container">
          <div class="row pb-5 col-xl-9 m-auto g-5">
            <div
              className="page_details_inner wow fadeInUp"
              data-wow-delay="0.2s"
            >
              <h4 className="text-white">VISION</h4>
              <p className="text-white text-left">
                KTIG envisions becoming a globally recognized leader in
                innovation and technology, driving transformative solutions for
                a sustainable future. Our vision is to empower businesses with
                cutting-edge tools and strategies that foster growth,
                efficiency, and resilience. We aim to bridge the gap between
                technology and human needs, creating impactful solutions that
                improve lives. Collaboration, integrity, and creativity form the
                core of our values, guiding every decision we make. Together, we
                aspire to shape a better world through the relentless pursuit of
                excellence and innovation.
              </p>
              <h4 className="text-white">MISSION</h4>
              <p className="text-white text-left">
                KTIG’s mission is to deliver innovative and high-quality
                solutions that address the evolving needs of businesses and
                communities. We strive to empower our clients through advanced
                technologies, ensuring sustainable growth and long-term success.
                At the heart of our work is a commitment to excellence,
                integrity, and customer satisfaction. By fostering collaboration
                and embracing innovation, we aim to create meaningful impacts
                that drive progress. Our goal is to be a trusted partner in
                building a brighter, more connected future for all.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />

      <a
        href="#"
        class="btn btn-secondary btn-lg-square rounded-circle back-to-top"
      >
        <i class="fa fa-arrow-up"></i>
      </a>
    </div>
  );
};

export default VisionandMission;
